// extracted by mini-css-extract-plugin
module.exports = {"tableCollapse":"OverviewTable_tableCollapse__kwTz7","header":"OverviewTable_header__14XUt","body":"OverviewTable_body__-iE-A","tableHover":"OverviewTable_tableHover__2bTgw"};